<template>
  <FlotoDrawer :open="showDrawer" @hide="hideDrawer">
    <template v-slot:title> {{ title }} </template>
    <template v-slot:trigger="slotData">
      <slot
        name="trigger"
        v-bind="slotData"
        :show-drawer="() => (showDrawer = true)"
      >
        <a href="javascript:;" class="text-neutral" @click="showDrawer = true">
          <EditorButton title="Insert knowledge">
            <MIcon
              name="lightbulb-on"
              :size="size"
              class="text-neutral-darker"
            />
          </EditorButton>
          <!-- {{ $t('insert_knowledge') }} -->
        </a>
      </slot>
    </template>
    <SuggestedKnowledge
      v-if="!disabled && !hideSuggestedKnowledge"
      :resource="resource"
      @insert="handleInsertKnowledge"
    />
    <KBSelectionList
      ref="kbListRef"
      :key="knowledgeType"
      :selectable="!disabled"
      searchable
      :max-allowed-selection="1"
      :fetch-fn="
        !hideSuggestedKnowledge && knowledgeType === 'suggestedKb'
          ? fetchKnowledgeFn
          : undefined
      "
      :allow-keywords="
        !hideSuggestedKnowledge && knowledgeType === 'suggestedKb'
          ? false
          : true
      "
      @selection-change="setSelectedItems"
    >
      <template v-slot:after-title>
        <FlotoDropdownPicker
          v-if="!hideSuggestedKnowledge"
          v-model="knowledgeType"
          as-input
          :options="options"
          :allow-clear="false"
          @change="handleTypeChange"
        >
          <template v-slot:trigger="{ currentItem, toggle }">
            <div
              ref="trigger"
              tabindex="0"
              role="button"
              class="inline-block mx-2 text-neutral cursor-pointer md-text-base"
              @keydown="handleKeyDown"
            >
              {{ (currentItem || {}).text }}
              <MIcon name="chevron-down" class="mx-1" />
            </div>
          </template>
        </FlotoDropdownPicker>
      </template>
    </KBSelectionList>
    <template v-slot:actions="{ hide }">
      <div v-if="!disabled">
        <MButton
          :disabled="selectedItems.length === 0"
          outline
          class="mr-2"
          :loading="processing"
          @click="handleAddKb"
        >
          {{ $t('insert_knowledge') }}
        </MButton>
        <MButton
          :disabled="selectedItems.length === 0"
          outline
          class="mr-2"
          :loading="processing"
          @click="handleAddLink"
        >
          {{ $t('insert_link') }}
        </MButton>
      </div>
      <MButton variant="default" @click="hide">
        {{ disabled ? $tc('done') : $t('cancel') }}
      </MButton>
    </template>
  </FlotoDrawer>
</template>

<script>
import { authComputed } from '@state/modules/auth'
import { relatedKnowledgeApi } from '@modules/knowledge/knowledge-api'
import KBSelectionList from '@components/item-selection-list/knowledge-list'
import SuggestedKnowledge from './suggested-knowledge.vue'
import { keyEvents } from '@utils/keyevents'
import EditorButton from '@components/editor/editor-button.vue'
export default {
  name: 'InsertKnowledge',
  components: { KBSelectionList, SuggestedKnowledge, EditorButton },
  props: {
    size: { type: String, default: 'md' },
    resource: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    title: {
      type: String,
      default() {
        return `${this.$t('insert_knowledge')}`
      },
    },
    hideSuggestedKnowledge: { type: Boolean, default: false },
  },
  data() {
    this.options = [
      { text: this.$tc('suggested_kb'), key: 'suggestedKb' },
      { text: this.$tc('all_kb'), key: 'allKb' },
    ]
    return {
      processing: false,
      showDrawer: false,
      selectedItems: [],
      knowledgeType: !this.hideSuggestedKnowledge ? 'suggestedKb' : 'allKb',
    }
  },
  computed: {
    ...authComputed,
  },
  methods: {
    handleTypeChange() {
      this.$nextTick(() => {
        this.refresh()
      })
    },
    handleKeyDown($event) {
      if ($event instanceof KeyboardEvent && $event.key === keyEvents.SPACE) {
        $event.preventDefault()
        this.$refs.trigger.click()
      }
    },
    fetchKnowledgeFn(_, criterias, limit, offset) {
      return relatedKnowledgeApi(
        this.isPortalLogin,
        this.resource.subject,
        criterias,
        limit,
        offset
      )
    },
    handleAddKb() {
      this.$emit('selected', this.selectedItems[0])
      this.hideDrawer()
      this.selectedItems = []
    },
    handleAddLink() {
      this.$emit('selected', this.selectedItems[0], true)
      this.hideDrawer()
      this.selectedItems = []
    },
    hideDrawer() {
      this.showDrawer = false
    },
    setSelectedItems(items) {
      this.selectedItems = items
    },
    refresh() {
      this.$refs.kbListRef.refresh()
    },
    handleInsertKnowledge(kb) {
      this.$emit('selected', kb)
      this.hideDrawer()
    },
  },
}
</script>
